import { ClientFormInput, ClientFormInputWithToAgencyInput } from 'src/types';

export type EStoreAgencyInfo = {
  name: string;
  slug: string;
  tel: string;
  telDemandesEstore?: string;
  address: string;
  zip?: string;
  city: {
    name: string;
    country: {
      name: string;
    };
  };
};

export type EStoreClientRequestForm = {
  sender: ClientFormInput;
  receiver: ClientFormInput | null;
  senderIsNotReceiver: boolean;
  colisNumber: number;
  description: string;
  toAgency: string;
};

export type EStoreAgencyState = {
  isLoading: boolean;
  error: Error | null;
  info: EStoreAgencyInfo | null;
  agencies: EStoreAgencyInfo[];
};

export type EStoreSubmitDataState = {
  isLoading: boolean;
  error: Error | null;
  success: string | null;
};

export type EStoreInitialState = {
  agency: EStoreAgencyState;
  form: EStoreClientRequestForm;
  submitData: EStoreSubmitDataState;
  marketingAgencyId?: string;
};

export type EStoreSetAgencyLoader = {
  isLoading: boolean;
};

export type EStoreSetAgencyError = {
  error: Error | null;
};

export type EStoreSetAgencyInfo = {
  info: EStoreAgencyInfo | null;
};

export type EStoreSetAgenciesList = {
  agencies: EStoreAgencyInfo[];
};

export const START_LOADING_AGENCY_INFO = 'eStore/start/loadingAgency';

export const ESTORE_SUBMIT_DATA_INFO = 'eStore/start/submit/data/info';

export type StartLoadingAgencyInfoAction = {
  type: typeof START_LOADING_AGENCY_INFO;
  slug: string;
};

export type EStoreStartSubmitFormData = {
  type: typeof ESTORE_SUBMIT_DATA_INFO;
};
export type SetEStoreSenderAction = {
  sender: ClientFormInputWithToAgencyInput;
};

export type SetEStoreReceiverAction = {
  receiver: ClientFormInput | null;
};

export type SetEStoreSenderIsNotReceiverAction = {
  senderIsNotReceiver: boolean;
};

export type SetEStoreColisNumberAndDescriptionAction = {
  colisNumber: number;
  description: string;
};

export type SetEStoreSubmitDataSetLoaderAction = {
  isLoading: boolean;
};

export type SetEStoreSubmitDataSetErrorAction = {
  error: Error | null;
};

export type SetEStoreSubmitDataSetSuccessAction = {
  success: string | null;
};
